/** @clearscore/helpers.envs v1.19.10: 2022-12-12 17:54 (assemble v5.5.1) **/
import { resolveProp } from '@clearscore/helpers.resolve-props';
import canUseDom from '@clearscore/helpers.can-use-dom';
var CACHE_NAME = '__cs__';
var LOCAL_NAMESPACE = 'local';
var RESET_MARKET_ENVS = {
  local: {}
};
/**
 * Returns an env after providing a object path
 * @param path
 * @return {*}
 */

function getSingleEnv(path) {
  if (!canUseDom()) return ''; // @todo: [PM] get envs on the server

  var envs;
  if (window[CACHE_NAME] && window[CACHE_NAME].env) {
    envs = window[CACHE_NAME].env;
  } else {
    envs = window.env;
  }
  return resolveProp("".concat(LOCAL_NAMESPACE, ".").concat(path), envs) || resolveProp(path, envs);
}
var getEnvs = function getEnvs() {
  if (!canUseDom()) return '';
  return window[CACHE_NAME].env || window.env;
};
/**
 * Set envs
 * @param envs - new market envs
 * @return void
 */

var setEnvs = function setEnvs() {
  var envs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  if (window[CACHE_NAME] && window[CACHE_NAME].env) {
    window[CACHE_NAME].env = Object.assign(window[CACHE_NAME].env, envs);
  } else {
    window.env = Object.assign(window.env, envs);
  }
};
/**
 * Returns an env after providing a object path or array of multiple object paths
 * @param paths
 * @return {*}
 */

function getEnv(paths) {
  if (Array.isArray(paths)) {
    return paths.map(function (path) {
      return getSingleEnv(path);
    });
  }
  return getSingleEnv(paths);
}
export { RESET_MARKET_ENVS, getEnv as default, getEnvs, setEnvs };